import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context';
import { api, errorText, upload } from '../api';

export function useQuickOrder() {
  const { addItems } = useApp();
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const updateText = value => { setText(value); setRows(null); };
  async function validate(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try { setRows((await api.post('/quick-order/validate', { csv_text: text })).data.rows); }
    catch (requestError) { setError(errorText(requestError)); }
    finally { setBusy(false); }
  }
  async function read(event) {
    const input = event.target;
    const file = input.files?.[0];
    if (!file) return;
    setBusy(true);
    setError('');
    try { await upload(file); updateText(await file.text()); }
    catch (uploadError) { setError(uploadError.response ? errorText(uploadError) : uploadError.message); }
    finally { setBusy(false); input.value = ''; }
  }
  const addToRequest = () => {
    addItems(rows.map(row => ({ product: row.product, quantity: row.quantity })));
    navigate('/rfq');
  };
  return { text, rows, busy, error, updateText, validate, read, addToRequest };
}

export function downloadTemplate() {
  const text = 'sku,quantity\nBRG-6205-2RS,50\nFST-M12-SS304,500\nPKG-5PLY-1812,250';
  const url = URL.createObjectURL(new Blob([text], { type: 'text/csv' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'superhub-order-template.csv';
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}